import { useEffect } from "react";
import useEspaceActif, { ESPACES } from "../../../hooks/useEspaceActif/useEspaceActif";

const ClasseEspaceActif = () => {
  const { espace } = useEspaceActif();

  useEffect(() => {
    document.body.classList.toggle("espace-particulier", espace === ESPACES.PARTICULIER);
    return () => document.body.classList.remove("espace-particulier");
  }, [espace]);

  return null;
};

export default ClasseEspaceActif;
